import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { styled } from "@mui/system";
import React, { useEffect, useState } from "react";

import { logout } from "@helpers/utils";

import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { agreeToTerms, fetchTerms } from "../../../store/slices/authSlice";
import CheckboxField from "./CheckboxField";

// (HOPE) I moved the styling from commonStyles to here because it's only used here and with the new mui v5 way of styling, I couldn't import it the same way
const FormRow = styled("div")(({ theme }) => ({
  padding: theme.spacing(1),
}));

const FormContainer = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  paddingBottom: theme.spacing(5),
}));

const ONLY_WHITESPACES_RE = /^\s*$/;

function Terms() {
  const dispatch = useAppDispatch();

  const terms = useAppSelector((state) => state.auth.terms);
  const user = useAppSelector((state) => state.auth.user);

  const mustGetTerms = user ? !user.termsAgreed : false;

  useEffect(() => {
    if (mustGetTerms) {
      dispatch(fetchTerms());
    }
  }, [mustGetTerms, dispatch]);

  const open = mustGetTerms && !!terms;

  const paragraphs = terms
    ? terms.split("\n").filter((p) => !ONLY_WHITESPACES_RE.test(p))
    : [];

  const [agreed, setAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAgreeToTerms = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!agreed) return;
    setIsSubmitting(true);
    await dispatch(agreeToTerms());
    setIsSubmitting(false);
  };

  return (
    <Dialog open={open} scroll="paper" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Terms of Service</DialogTitle>
      <DialogContent dividers={true}>
        {paragraphs.map((paragraph, key) => (
          <DialogContentText key={key}>{paragraph}</DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        <FormContainer noValidate onSubmit={handleAgreeToTerms}>
          <FormRow>
            <CheckboxField
              checked={agreed}
              label="I have read and agree to the terms of service"
              onChange={(_event, checked) => {
                setAgreed(checked);
              }}
            />
            <Button color="primary" onClick={logout}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={!agreed || isSubmitting}
            >
              Continue
            </Button>
          </FormRow>
        </FormContainer>
      </DialogActions>
    </Dialog>
  );
}

export default Terms;
